<template>
  <div id="register-user" :style="{height : registerUserHeight}">
    <div id="container">
      <div id="content">
        <div v-if="!isRegistrableUrl && isRegistrableUrl != null">
          本登録が完了している。またはURLの有効期限が過ぎています。<br>
          ログインが出来ない場合は再度仮登録から行ってください。
        </div>
        <div v-if="isRegistrableUrl">
          <div id="page-title">ユーザー本登録</div>
          <div class="input_area" ref="inputArea">
            <ul class="qa_input">
              <li><!-- ユーザー情報 -->
                <ul class="important_title">
                  <li>
                    <label class="important">必須</label>登録者情報について教えてください。
                  </li>
                </ul>
                <ul>
                  <li>
                    <span class="label qa_title">
                      <span class="important_asterisk">*&nbsp;</span>企業名
                    </span>
                    <input type="text" v-model="form.corpName"
                     :class="{validation_error: validateErrorMessages.corpName != ''}" placeholder="企業名">
                    <div class="validate_error_messages">{{ validateErrorMessages.corpName }}</div>
                  </li>
                  <li>
                    <span class="label">
                     <span class="important_asterisk">*&nbsp;</span>省略企業名
                    </span>
                    <input type="text" v-model="form.corpNameShort"
                     :class="{validation_error: validateErrorMessages.corpNameShort != ''}" autocomplete="none" placeholder="省略企業名">
                    <div class="valid_description">登録される企業名を16文字以内で設定してください。</div>
                    <div class="validate_error_messages">{{ validateErrorMessages.corpNameShort }}</div>
                  </li>
                  <li>
                    <span class="label">
                     <span class="important_asterisk">*&nbsp;</span>郵便番号
                    </span>
                    <input type="text" v-model="form.postcd" @keypress="validateNumber"
                     :class="{validation_error: validateErrorMessages.postcd != ''}"
                     @input="form.postcd=inputRestNumber($event)" @blur="addressCompletion"  maxlength="7" placeholder="郵便番号"/>
                    <div class="valid_description">半角数値、ハイフン不要</div>
                    <div class="validate_error_messages">{{ validateErrorMessages.postcd }}</div>
                  </li>
                  <li>
                    <span class="label">
                      <span class="important_asterisk">*&nbsp;</span>住所
                    </span>
                    <span class="list_box">
                      <input type="text" v-model="form.state"
                       :class="{validation_error: validateErrorMessages.state != ''}" placeholder="都道府県">
                      <input type="text" v-model="form.city"
                       :class="{validation_error: validateErrorMessages.city != ''}" placeholder="市区町村">
                    </span>
                    <div class="validate_error_messages">{{ validateErrorMessages.state }}</div>
                    <div class="validate_error_messages">{{ validateErrorMessages.city }}</div>
                  </li>
                  <li>
                    <span class="label">
                      <span class="important_asterisk">*&nbsp;</span>その他住所/番地
                    </span>
                    <input type="text" v-model="form.street"
                     :class="{validation_error: validateErrorMessages.street != ''}" placeholder="その他住所/番地">
                    <div class="validate_error_messages">{{ validateErrorMessages.street }}</div>
                  </li>
                  <li>
                    <span class="label">
                      <span class="important_asterisk">*&nbsp;</span>電話番号
                    </span>
                    <input type="tel" v-model="form.tel" @keypress="validateNumber"
                     :class="{validation_error: validateErrorMessages.tel != ''}"
                     @input="form.tel=inputRestNumber($event)" placeholder="電話番号"/>
                    <div class="valid_description">半角数値、ハイフン不要</div>
                    <div class="validate_error_messages">{{ validateErrorMessages.tel }}</div>
                  </li>
                  <li>
                    <span class="label">
                      <span class="important_asterisk">*&nbsp;</span>登録者名
                    </span>
                    <span class="list_box">
                      <input type="text" v-model="form.registrantLastName"
                       :class="{validation_error: validateErrorMessages.registrantLastName != ''}" placeholder="姓">
                      <input type="text" v-model="form.registrantFirstName"
                       :class="{validation_error: validateErrorMessages.registrantFirstName != ''}" placeholder="名">
                    </span>
                    <div class="validate_error_messages">{{ validateErrorMessages.registrantLastName }}</div>
                    <div class="validate_error_messages">{{ validateErrorMessages.registrantFirstName }}</div>
                  </li>
                  <li>
                    <span class="label">
                      <span class="important_asterisk">*&nbsp;</span>登録者名（カナ）
                    </span>
                    <span class="list_box">
                      <input type="text" v-model="form.registrantLastNameKane" @keypress="validateKana"
                       :class="{validation_error: validateErrorMessages.registrantLastNameKane != ''}"
                       @input="form.registrantLastNameKane=inputRestKana($event)" placeholder="姓（カナ）"/>
                      <input type="text" v-model="form.registrantFirstNameKane" @keypress="validateKana"
                       :class="{validation_error: validateErrorMessages.registrantFirstNameKane != ''}"
                       @input="form.registrantFirstNameKane=inputRestKana($event)" placeholder="名（カナ）"/>
                    </span>
                    <div class="validate_error_messages">{{ validateErrorMessages.registrantLastNameKane }}</div>
                    <div class="validate_error_messages">{{ validateErrorMessages.registrantFirstNameKane }}</div>
                  </li>
                  <li>
                    <span class="label">
                      <span class="important_asterisk">*&nbsp;</span>メールアドレス/ログインID
                    </span>
                    <input class="mail" type="text" v-model="form.email"
                     :class="{validation_error: validateErrorMessages.email != ''}" readonly placeholder="メールアドレス/ログインID"/>
                    <div class="validate_error_messages">{{ validateErrorMessages.email }}</div>
                  </li>
                  <li>
                    <span class="label">
                      <span class="important_asterisk">*&nbsp;</span>パスワード
                    </span>
                    <input type="password" v-model="form.password"
                     :class="{validation_error: validateErrorMessages.password != ''}" placeholder="パスワード"/>
                    <div class="valid_description">半角英小文字、数字を含む8文字以上20文字以下のパスワードを設定してください。</div>
                    <div class="validate_error_messages">{{ validateErrorMessages.password }}</div>
                  </li>
                  <li>
                    <span class="label">
                      <span class="important_asterisk">*&nbsp;</span>パスワード(確認用)
                    </span>
                    <input type="password" v-model="form.confirmPassword"
                     :class="{validation_error: validateErrorMessages.confirmPassword != ''}"
                     placeholder="パスワード(確認用)"/>
                    <div class="validate_error_messages">{{ validateErrorMessages.confirmPassword }}</div>
                  </li>
                </ul>
              </li><!-- ユーザー情報 -->
              <li><!-- アンケート -->
                <ul class="important_title">
                  <li>
                    <label class="important">必須</label>企業情報について教えてください 。
                  </li>
                </ul>
                <ul>
                  <li>
                    <span class="label qa_title">
                      <span class="important_asterisk">*&nbsp;</span>対象市場を選択してください。
                    </span>
                    <ul>
                      <li>
                        <input type="checkbox" id="residential" v-model="form.opQnMarketTypes" value="0">
                        <label for="residential">住宅市場</label>
                        <input type="checkbox" id="non_residential" v-model="form.opQnMarketTypes" value="1">
                        <label for="non_residential">非住宅市場</label>
                      </li>
                      <li>
                        <input type="checkbox" id="market_other" v-model="form.opQnMarketTypes" value="2">
                        <label for="market_other">その他（詳しく教えてください。）</label>
                        <input type="text" v-model="form.opQnMarketDetail"
                         :class="{validation_error: validateErrorMessages.opQnMarketDetail != ''}">
                      </li>
                    </ul>
                    <div class="validate_error_messages" v-if="validateErrorMessages.opQnMarketTypes">
                      {{ validateErrorMessages.opQnMarketTypes }}
                    </div>
                    <div class="validate_error_messages" v-if="validateErrorMessages.opQnMarketDetail">
                      {{ validateErrorMessages.opQnMarketDetail }}
                    </div>
                  </li>
                </ul>
                <ul>
                  <li>
                    <span class="label qa_title">
                      <span class="important_asterisk">*&nbsp;</span>対象製品を選択してください。
                    </span>
                    <ul>
                      <li>
                        <input type="checkbox" id="storage" v-model="form.opQnProductsTypes" value="0">
                        <label for="storage">収納類</label>
                        <input type="checkbox" id="kitchen" v-model="form.opQnProductsTypes" value="1">
                        <label for="kitchen">水廻り</label>
                      </li>
                      <li>
                        <input type="checkbox" id="product_other" v-model="form.opQnProductsTypes" value="2">
                        <label for="product_other">その他（詳しく教えてください。）</label>
                        <input type="text" v-model="form.opQnProductsDetail"
                         :class="{validation_error: validateErrorMessages.opQnProductsDetail != ''}">
                      </li>
                    </ul>
                    <div class="validate_error_messages" v-if="validateErrorMessages.opQnProductsTypes">
                      {{ validateErrorMessages.opQnProductsTypes }}
                    </div>
                    <div class="validate_error_messages" v-if="validateErrorMessages.opQnProductsDetail">
                      {{ validateErrorMessages.opQnProductsDetail }}
                    </div>
                  </li>
                </ul>
                <ul>
                  <li class="qa_title">
                    <span class="label ">
                      <span class="important_asterisk">*&nbsp;</span>別注特注割合を教えてください。
                      <span class="valid_description"><br>（半角数字で入力してください。）</span>
                    </span>
                    <ul class="container">
                      <li style="display: block; width: 50%;">
                        <span class="number_label">規格品</span>
                        <input type="number" style="width:50px;" v-model="form.opQnStandardProductRate">%
                      </li>
                      <li style="display: block; width: 50%;">
                        <span class="number_label">別注・特注</span>
                        <input type="number" style="width:50px;" v-model="form.opQnBespokeCustomRate">%
                      </li>
                    </ul>
                    <div class="validate_error_messages">{{ validateErrorMessages.opQnStandardProductRate }}</div>
                    <div class="validate_error_messages">{{ validateErrorMessages.opQnBespokeCustomRate }}</div>
                  </li>
                </ul>
                <ul>
                  <li class="qa_title">
                    <span class="label">
                      <span class="important_asterisk">*&nbsp;</span>darosにご関心を持たれた理由を選択してください。
                    </span>
                    <ul>
                      <li>
                        <input type="checkbox" id="order" value="0" v-model="form.opQnDarosInterestTypes">
                        <label for="order">別注・特注対応</label>
                        <input type="checkbox" id="new_business" value="1" v-model="form.opQnDarosInterestTypes">
                        <label for="new_business">新規事業に</label>
                      </li>
                      <li>
                        <input type="checkbox" id="reason_other" value="2" v-model="form.opQnDarosInterestTypes">
                        <label for="reason_other">その他（詳しく教えてください。）</label>
                        <input type="text" v-model="form.opQnDarosInterestDetail"
                         :class="{validation_error: validateErrorMessages.opQnDarosInterestDetail != ''}">
                      </li>
                    </ul>
                    <div class="validate_error_messages" v-if="validateErrorMessages.opQnDarosInterestTypes">
                      {{ validateErrorMessages.opQnDarosInterestTypes }}
                    </div>
                    <div class="validate_error_messages" v-if="validateErrorMessages.opQnDarosInterestDetail">
                      {{ validateErrorMessages.opQnDarosInterestDetail }}
                    </div>
                  </li>
                </ul>
                <ul>
                  <li>
                    <span class="label qa_title">
                      <span class="important_asterisk">*&nbsp;</span>受注先（販売先）を選択してください。
                    </span>
                    <ul>
                      <li>
                        <div class="check_label" v-for="(orderPlaceItem, idx) in orderPlaceItems" :key="idx">
                          <input type="checkbox" :id="'order-place-' + idx"
                           :value="idx" v-model="form.opQnOrderPlaceTypes">
                          <label :for="'order-place-' + idx">{{orderPlaceItem}}</label>
                        </div>
                      </li>
                      <li>
                        <input type="checkbox" id="customer_other" value="6" v-model="form.opQnOrderPlaceTypes">
                        <label for="customer_other">その他（詳しく教えてください。）</label>
                        <input type="text" v-model="form.opQnOrderPlaceDetail"
                         :class="{validation_error: validateErrorMessages.opQnOrderPlaceDetail != ''}">
                      </li>
                    </ul>
                    <div class="validate_error_messages" v-if="validateErrorMessages.opQnOrderPlaceTypes">
                      {{ validateErrorMessages.opQnOrderPlaceTypes }}
                    </div>
                    <div class="validate_error_messages" v-if="validateErrorMessages.opQnOrderPlaceDetail">
                      {{ validateErrorMessages.opQnOrderPlaceDetail }}
                    </div>
                  </li>
                </ul>
                <ul>
                  <li>
                    <span class="label qa_title">
                      <span class="important_asterisk">*&nbsp;</span>生産量を教えてください。
                      <span class="valid_description"><br>（半角数字で入力してください。）</span>
                    </span>
                  </li>
                  <ul>
                    <li>
                      <select class="qa_select" v-model="form.opQnProductionUnit">
                        <option value="0">月</option>
                        <option value="1">日</option>
                      </select>
                      <input type="number" style="width:50px;" v-model="form.opQnProductionNum"
                       :class="{validation_error: validateErrorMessages.opQnProductionNum != ''}">箱
                      <div class="validate_error_messages">{{ validateErrorMessages.opQnProductionNum }}</div>
                    </li>
                  </ul>
                  <li>
                    <span class="label qa_title">
                      <span class="important_asterisk">*&nbsp;</span>設計者など間接業務人員数を教えてください。
                      <span class="valid_description"><br>（半角数字で入力してください。）</span>
                    </span>
                    <ul>
                      <li>
                        <input type="number" style="width:50px;" v-model="form.opQnIndirectPersonnelNum"
                         :class="{validation_error: validateErrorMessages.opQnIndirectPersonnelNum != ''}">&nbsp;名
                        <div class="validate_error_messages">{{ validateErrorMessages.opQnIndirectPersonnelNum }}</div>
                      </li>
                    </ul>
                  </li>
                </ul>
              </li><!-- アンケート -->
            </ul>
            <div class="rule_parts" >
              <dd-user-rule-detail
                :dispTitle="true"
              />
            </div>
            <ul class="consent">
              <li>
                <label>
                  <input type="checkbox" v-model="consent"/>
                  利用規約に同意する。
                </label>
              </li>
            </ul>
            <ul class="qa_input">
              <div class="validate_error_messages" v-if="dispValidateErrorMessages.length > 0">
                入力内容に以下のエラーがあります。<br>
                項目をご確認の上、もう一度入力してください。
              </div>
              <div class="validate_error_messages"
                 v-for="(validationErrorMessage, idx) in dispValidateErrorMessages" :key="idx">
                {{ validationErrorMessage }}
              </div>
              <button type="submit" class="registration_button"
                  v-bind:class="{img_disable: submitDisable || !consent}" @click="submitRegisterUser">
                登録
              </button>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <dd-footer />
    <!-- ローディングモーダル -->
    <dd-loading-modal ref="loadingModalRef" />
  </div>

</template>

<script>
import axios from 'axios'
import * as Api from '../utils/Api'
import {API_URL, STORAGE_KEY} from '../constants/App'
import * as App from '../utils/App'
import Footer from '../components/common/Footer'
import LoadingModal from '../components/common/LoadingModal'
import UserRuleDetail from '../components/common/UserRuleDetail'
import * as Check from '../utils/Check'
import * as FormUtil from '../utils/FormUtil'

export default {
  name: 'RegisterUser',
  components: {
    'dd-footer': Footer,
    'dd-loading-modal': LoadingModal,
    'dd-user-rule-detail': UserRuleDetail
  },
  data () {
    return {
      // 登録可能なURLかどうか
      isRegistrableUrl: null,
      /** フォーム */
      form: {
        // ユーザー情報
        corpName: '',
        corpNameShort: '',
        postcd: '',
        state: '',
        city: '',
        street: '',
        tel: '',
        registrantLastName: '',
        registrantFirstName: '',
        registrantLastNameKane: '',
        registrantFirstNameKane: '',
        email: '',
        password: '',
        confirmPassword: '',
        // アンケート
        opQnMarketTypes: [],
        opQnMarketDetail: '',
        opQnProductsTypes: [],
        opQnProductsDetail: '',
        opQnStandardProductRate: '',
        opQnBespokeCustomRate: '',
        opQnDarosInterestTypes: [],
        opQnDarosInterestDetail: '',
        opQnOrderPlaceTypes: [],
        opQnOrderPlaceDetail: '',
        opQnProductionUnit: 0,
        opQnProductionNum: '',
        opQnIndirectPersonnelNum: ''
      },
      /** アンケート項目 */
      orderPlaceItems: ['メーカー', '商社', '建材店', 'ビルダー/工務店社', '設計事務所', 'エンドユーザー'],
      consent: false,
      /** 共通エラーメッセージ */
      errorMessage: { text: '' },
      /** 項目別エラーメッセージ */
      validateErrorMessages: {
        // ユーザー情報
        corpName: '',
        corpNameShort: '',
        postcd: '',
        state: '',
        city: '',
        street: '',
        tel: '',
        registrantLastName: '',
        registrantFirstName: '',
        registrantLastNameKane: '',
        registrantFirstNameKane: '',
        email: '',
        password: '',
        confirmPassword: '',
        // アンケート
        opQnMarketTypes: '',
        opQnMarketDetail: '',
        opQnProductsTypes: '',
        opQnProductsDetail: '',
        opQnStandardProductRate: '',
        opQnBespokeCustomRate: '',
        opQnDarosInterestTypes: '',
        opQnDarosInterestDetail: '',
        opQnOrderPlaceTypes: '',
        opQnOrderPlaceDetail: '',
        opQnProductionNum: '',
        opQnIndirectPersonnelNum: ''
      },
      submitDisable: false,
      registerUserHeight: ''
    }
  },
  computed: {
    /* 設定されてるエラーメッセージをリストにして返す */
    dispValidateErrorMessages: function () {
      return Object.keys(this.validateErrorMessages)
        .filter(function (key) {
          return this.validateErrorMessages[key] !== '' && key !== 'CustomConstraint'
        }.bind(this))
        .map(function (key) {
          return this.validateErrorMessages[key]
        }.bind(this))
    }
  },
  methods: {
    /** inputの数字チェック */
    validateNumber: function (event) {
      if (!Check.isNumber(event.key)) {
        event.preventDefault()
        return false
      }
      return true
    },
    /** inputのカナチェック */
    validateKana: function (event) {
      if (!Check.isKana(event.key)) {
        event.preventDefault()
        return false
      }
      return true
    },
    /** inputに数字のみ許容 */
    inputRestNumber: function (event) {
      // テキスト補正
      let str = FormUtil.restHalfNumber(event.target.value)
      if (str.length <= 0) {
        return ''
      }
      return str
    },
    /** inputにカナのみ許容 */
    inputRestKana: function (event) {
      // テキスト補正
      let str = FormUtil.restKana(event.target.value)
      if (str.length <= 0) {
        return ''
      }
      return str
    },
    /** 郵便番号から住所を設定 */
    addressCompletion: function () {
      FormUtil.addressCompletion(this.form.postcd, (address) => {
        this.$set(this.form, 'state', address.state)
        this.$set(this.form, 'city', address.city)
        this.$set(this.form, 'street', address.street)
      })
    },
    /** エラーメッセージのクリア */
    clearErrorMessages: function () {
      this.errorMessage = { text: '' }
      Object.keys(this.validateErrorMessages)
        .forEach(function (key) {
          this.validateErrorMessages[key] = ''
        }.bind(this))
    },
    /** 登録実行 */
    submitRegisterUser: function () {
      this.submitDisable = true
      this.$refs.loadingModalRef.showModal(true)
      this.clearErrorMessages()
      let payload = {
        corpName: this.form.corpName,
        corpNameShort: this.form.corpNameShort,
        postcd: this.form.postcd,
        state: this.form.state,
        city: this.form.city,
        street: this.form.street,
        tel: this.form.tel,
        registrantLastName: this.form.registrantLastName,
        registrantFirstName: this.form.registrantFirstName,
        registrantLastNameKane: this.form.registrantLastNameKane,
        registrantFirstNameKane: this.form.registrantFirstNameKane,
        email: this.form.email,
        loginId: this.form.email,
        password: this.form.password,
        confirmPassword: this.form.confirmPassword,
        isDebug: false,
        opQnMarketTypes: this.form.opQnMarketTypes,
        opQnMarketDetail: this.form.opQnMarketDetail,
        opQnProductsTypes: this.form.opQnProductsTypes,
        opQnProductsDetail: this.form.opQnProductsDetail,
        opQnStandardProductRate: this.form.opQnStandardProductRate,
        opQnBespokeCustomRate: this.form.opQnBespokeCustomRate,
        opQnDarosInterestTypes: this.form.opQnDarosInterestTypes,
        opQnDarosInterestDetail: this.form.opQnDarosInterestDetail,
        opQnOrderPlaceTypes: this.form.opQnOrderPlaceTypes,
        opQnOrderPlaceDetail: this.form.opQnOrderPlaceDetail,
        opQnProductionUnit: this.form.opQnProductionUnit,
        opQnProductionNum: this.form.opQnProductionNum,
        opQnIndirectPersonnelNum: this.form.opQnIndirectPersonnelNum
      }
      axios.post(API_URL.ADMIN + '/complete-trial-user', payload
      ).then(response => {
        this.$refs.loadingModalRef.showModal(false)
        App.removeLocalStorage(STORAGE_KEY.USER_INFO)
        alert('本登録が完了しました')
        this.$router.push('/login')
      }).catch(error => {
        this.$refs.loadingModalRef.showModal(false)
        // カスタムバリデーションが配列で帰るため、再設定する
        this.reSettingValidErrors(error)
        Api.handleError(error, this.errorMessage, this.validateErrorMessages)
      }).finally(() => {
        this.submitDisable = false
      })
    },
    /** バリデーションエラーの再設定 */
    reSettingValidErrors: function (error) {
      if (error.response.data.validationErrors == null) return
      let validationErrors = error.response.data.validationErrors
      if (validationErrors.CustomConstraint == null) return
      let CustomConstraint = validationErrors.CustomConstraint

      // パスワードの不一致のエラーメッセージ
      let differentPassword = CustomConstraint.find(e => e.match(/^パスワード/))
      if (validationErrors.confirmPassword == null && differentPassword != null) {
        error.response.data.validationErrors.confirmPassword = [differentPassword]
      }

      // その他の入力欄のエラーメッセージ
      let opQnMarketDetail = CustomConstraint.find(e => e.match(/^対象市場/))
      if (opQnMarketDetail != null) {
        error.response.data.validationErrors.opQnMarketDetail = [opQnMarketDetail]
      }
      let opQnProductsDetail = CustomConstraint.find(e => e.match(/^対象製品/))
      if (opQnProductsDetail != null) {
        error.response.data.validationErrors.opQnProductsDetail = [opQnProductsDetail]
      }
      let opQnDarosInterestDetail = CustomConstraint.find(e => e.match(/^darosにご関心を持たれた理由/))
      if (opQnDarosInterestDetail != null) {
        error.response.data.validationErrors.opQnDarosInterestDetail = [opQnDarosInterestDetail]
      }
      let opQnOrderPlaceDetail = CustomConstraint.find(e => e.match(/^受注先（販売先）/))
      if (opQnOrderPlaceDetail != null) {
        error.response.data.validationErrors.opQnOrderPlaceDetail = [opQnOrderPlaceDetail]
      }
    }
  },
  mounted: function () {
    // 有効なURLかチェック
    let payload = {
      userEmail: this.$route.query.email,
      token: this.$route.query.token
    }
    axios.post(API_URL.ADMIN + '/check-trial-user-token', payload
    ).then(response => {
      this.isRegistrableUrl = true
      this.form.email = this.$route.query.email
      this.registerUserHeight = 'auto'
    }).catch(error => {
      this.isRegistrableUrl = false
      this.registerUserHeight = 'calc(100% - 51px)'
      Api.handleError(error, this.errorMessage, this.validateErrorMessages)
    })
  }
}

</script>
<style lang="scss" scoped>
#register-user {
  background: #eee;
  min-height: 260px;
  min-width: 500px;
  height: calc(100% - 51px);
}
#container {
  height: 100%;
  display: flex;
  justify-content: center;
}
#content {
  padding-top: 30px;
  text-align: center;
  display: block;
  .input_area{
    padding: 20px 50px;
    border-radius: 5px;
    background-color: #fff;
    min-width: 673px;
    max-width: 673px;
    margin-bottom: 80px;
    .mail{
      background: #fafafa;
      &:focus {
        outline: none;
      }
    }
    input[type="text"] ,input[type="tel"] ,input[type="password"] {
      width: 100%;
    }
    input[type="checkbox"] {
      width: auto;
    }
    .consent {
      width: 470px;
      margin: 10px auto;
      text-align: left
    }
  }
  span.label {
    text-align: left;
    display: inline-block;
    min-width: 100%;
    font-weight: 400;
  }
}
#page-title {
  margin-bottom: 25px;
}

.error_message {
  margin: 10px;
}
.validate_error_messages {
  width: 100%;
  color: #dc3545;
  margin: 5px;
  text-align: left;
}
i {
  margin: 0 3px 0 5px;
  color: #ff4500;
  transform: translateY(5px);
}
.valid_description {
  font-size: 11.3px;
  text-align: left;
  margin: 2px 5px;
}
.rule_parts{
  width: 500px;
  text-align: left;
  margin: 80px auto 0;
}
.qa_input{
  max-width: 480px;
  margin:40px auto 10px;
  ul {
    font-size: 15px;
    li {
      line-height: 20px;
    }
  }
  li {
    text-align: left;
  }
  input {
    padding: .375rem 0 .375rem .5rem;
    margin: 2px 5px;
  }
  input[type=checkbox], input[type=radio]{
    vertical-align:0.1em;
  }
  .qa_select{
    width: 50px;
    height: 33px;
    margin: 5px;
  }
  .validation_error {
    background: #FFEFEF;
  }
  label{
    margin-right:10px;
  }
}
.qa_title{
  margin-top:20px;
}
.important_title {
  font-weight: bold;
  margin-top: 50px;
}
.important{
  color: #fff;
  background: #dc3545;
  display: inline-block;
  width: 40px;
  height: 20px;
  margin: 5px 0 2px;
  line-height: 22px;
  text-align: center;
  font-size: .8em;
  border-radius: 5px;
  font-weight: normal;
  vertical-align:bottom;
}
.important_asterisk {
  color:#dc3545;
}
.number_label{
  display: inline-block; width:80px;
  margin: 5px;
}
.check_label{
  display:inline-block;
}
.list_box {
  display: -ms-flexbox;
  display: flex;
  width:100%;
  input {
    margin-right: 20px;
  }
}
.registration_button {
  min-width: 180px;
  min-height: 40px;
  font-size: 1.1em;
  letter-spacing: 1px;
  display: inline-block;
  margin: 0 10px;
  padding: 1px 10px;
  line-height: 30px;
  background-image: linear-gradient(#eee,#ddd);
  border: 0;
  border-radius: .15rem;
  outline: 0;
  white-space: nowrap;
  box-shadow: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background: #000;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/main/js/pages/RegisterUser.vue